<template>
  <div>
  <nav class="navbar navbar-expand navbar-dark bg-primary">
    <div class="container-fluid container-3xl">
      <router-link class="navbar-brand fw-bold" to="/">
        <img src="../assets/logo.png" alt="logo" class="d-none d-md-inline-block me-3">
        AJA Time Tracking
      </router-link>
      <ul class="navbar-nav">
        <li
          class="nav-item d-none d-md-list-item position-relative"
          v-if="loginUser.role === 'Dir' || loginUser.role === 'PM'"
        >
          <router-link class="nav-link px-2.5 active fw-bold" to="/projects">
            專案管理
          </router-link>
          <span class="active-underline"></span>
        </li>
        <li
          class="nav-item d-none d-md-list-item position-relative"
          v-if="loginUser.role === 'Dir'"
        >
          <router-link class="nav-link px-2.5 active fw-bold" to="/users">
            使用者管理
          </router-link>
          <span class="active-underline"></span>
        </li>
        <li class="nav-item d-none d-md-list-item">
          <a class="nav-link cursor-reset" href="javascript:">
            <!-- separator -->
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active cursor-reset fw-bold" href="javascript:">
            {{ loginUser.first_name }} {{ loginUser.last_name }}
          </a>
        </li>
        <li class="nav-item d-list-item d-md-none align-self-center dropdown">
          <a
            class="nav-link active" data-bs-toggle="dropdown" href="#"
            role="button" aria-expanded="false" id="sitenav-menu-link"
          >
            <i class="bi bi-list"></i>
          </a>
          <ul
            class="dropdown-menu dropdown-menu-end min-w-auto z-2k"
            aria-labelledby="sitenav-menu-link"
          >
            <li v-if="loginUser.role === 'Dir' || loginUser.role === 'PM'">
              <router-link class="dropdown-item" to="/projects">專案管理</router-link>
            </li>
            <li v-if="loginUser.role === 'Dir'">
              <router-link class="dropdown-item" to="/users">使用者管理</router-link>
            </li>
            <li>
              <a class="dropdown-item" data-bs-toggle="modal" href="#logout-confirm-modal">登出</a>
            </li>
          </ul>
        </li>
        <li class="nav-item d-none d-md-list-item align-self-center">
          <a class="nav-link active" data-bs-toggle="modal" href="#logout-confirm-modal">
            <i class="bi bi-box-arrow-in-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </nav>
  <!-- 登出 modal start -->
  <div
    class="modal fade" id="logout-confirm-modal" tabindex="-1"
    data-bs-backdrop="static" data-bs-keyboard="false"
    aria-labelledby="logout-confirm-modal-label" aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="logout-confirm-modal-label">登出 Time Tracking</h5>
          <button
            type="button" class="btn-close"
            data-bs-dismiss="modal" aria-label="取消"
          ></button>
        </div>
        <div class="modal-body">
          確定要將帳號登出嗎？
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
          <button type="button" class="btn btn-danger" @click.prevent="logout">確定</button>
        </div>
      </div>
    </div>
  </div>
  <!-- 登出 modal end -->
  </div>
</template>

<script>
import { Modal } from 'bootstrap';
import { fetchApi } from '../utils/index';

export default {
  name: 'SiteNav',
  props: {
    loginUser: Object,
  },
  methods: {
    logout() {
      fetchApi('logout')
        .then((data) => {
          if (data.status === 0 || data.status === -1) {
            const modalElement = document.querySelector('#logout-confirm-modal');
            const modal = Modal.getOrCreateInstance(modalElement);
            modal.hide();
            this.$router.push('/login');
          } else {
            throw new Error(`${data.message} (${data.status})`);
          }
        })
        .catch((error) => {
          this.$parent.displayErrorToast(error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
// add d-{breakpoint}-list-item classes
$utilities: (
  "display": (
    responsive: true,
    print: true,
    property: display,
    class: d,
    values: inline inline-block block grid table table-row table-cell
            flex inline-flex list-item none,
  ),
);
@import "~bootstrap/scss/bootstrap-grid";
.container-fluid {
  @include media-breakpoint-up(md) {
    padding-left: 48px;
    padding-right: 48px;
  }
}
.container-3xl {
  @media (min-width: 1441px) {
    max-width: 1440px;
  }
}
.navbar-brand {
  font-size: 1rem;
  @include media-breakpoint-up(md) {
    font-size: 1.25rem;
  }
}
.navbar-brand img {
  width: 36px;
  height: 36px;
  vertical-align: -0.5em;
}
.active-underline {
  position: absolute;
  display: none;
  width: 100%;
  height: 6px;
  background-color: white;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
}
.router-link-active + .active-underline,
.nav-link:hover + .active-underline {
  display: block;
}
</style>
